import React, { useState, useRef, useEffect } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { ToggleButton, ToggleButtonGroup, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from '@mui/material';

const PeriodSelector = ({ selectedPeriod, onSelectPeriod, isCDI = false, disabled = false }) => {
  const defaultPeriods = isCDI ? ['3mois', '6mois'] : ['1mois', '3mois', '4mois', '6mois'];

  const [periods, setPeriods] = useState(() => {
    const stored = localStorage.getItem('periods');
    return stored ? JSON.parse(stored) : defaultPeriods;
  });

  const [open, setOpen] = useState(false);
  const [newPeriod, setNewPeriod] = useState('');
  const [lastAdded, setLastAdded] = useState(null);
  const buttonRefs = useRef({});

  const handleAddPeriod = () => {
    const trimmedPeriod = newPeriod.trim().toLowerCase();
    if (trimmedPeriod !== '' && !periods.includes(trimmedPeriod)) {
      const updated = [...periods, trimmedPeriod];

      const sorted = updated.sort((a, b) => {
        const extractNumber = (str) => parseInt(str.match(/\d+/)?.[0] || 0, 10);
        const isMonthA = a.includes('mois');
        const isMonthB = b.includes('mois');

        if (isMonthA && !isMonthB) return -1;
        if (!isMonthA && isMonthB) return 1;
        return extractNumber(a) - extractNumber(b);
      });

      setPeriods(sorted);
      localStorage.setItem('periods', JSON.stringify(sorted));
      onSelectPeriod(trimmedPeriod);
      setLastAdded(trimmedPeriod);
      setNewPeriod('');
      setOpen(false);
    }
  };

  useEffect(() => {
    if (lastAdded && buttonRefs.current[lastAdded]) {
      buttonRefs.current[lastAdded].focus();
      setLastAdded(null);
    }
  }, [periods, lastAdded]);

  return (
    <div style={{ marginTop: '12px', display: 'flex' }}>
      <ToggleButtonGroup
        value={selectedPeriod}
        exclusive
        onChange={(event, newValue) => {
          if (newValue !== null) {
            if (newValue === 'add') {
              setOpen(true);
            } else {
              onSelectPeriod(newValue);
            }
          }
        }}
        aria-label="Période du contrat"
        disabled={disabled}
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '8px',
          justifyContent: 'flex-start',
          '& .MuiToggleButton-root': {
            borderRadius: '20px',
            px: 2,
            py: 0.5,
            fontSize: '0.82rem',
            borderColor: '#e2e8f0',
            color: '#333',
            backgroundColor: '#f0f4f8',
            textTransform: 'none',
            fontWeight: '500',
            transition: '0.3s',
            '&:hover': {
              backgroundColor: '#e3f2fd',
            },
            '&.Mui-selected': {
              backgroundColor: '#03407b', 
              color: '#fff', 
              borderColor: '#03407b', 
              
              '&.Mui-disabled': {
                
                backgroundColor: 'rgba(3, 64, 123, 0.7)', 
                color: 'rgba(255, 255, 255, 0.8)', 
                borderColor: 'rgba(3, 64, 123, 0.7)',
                
                opacity: 1, 
              },
            },
            
            '&.Mui-disabled': {
              backgroundColor: '#e0e0e0', 
              color: '#a0a0a0', 
              borderColor: '#e0e0e0',
              cursor: 'not-allowed', 
              
              '&:hover': {
                backgroundColor: '#e0e0e0', 
                borderColor: '#e0e0e0',
              }}
          }
        }}
      >
        
        {periods.map((period, index) => (
          <ToggleButton
            key={index}
            value={period}
            ref={(el) => (buttonRefs.current[period] = el)}
            disabled={disabled}
          >
            {period.toUpperCase()}
          </ToggleButton>
        ))}
        {!isCDI && (
          <ToggleButton
            value="add"
            disabled={disabled}
          >
            <AddIcon sx={{ fontSize: 18 }} /></ToggleButton>
        )}
      </ToggleButtonGroup>

      {!isCDI && (
        <Dialog open={open} onClose={() => setOpen(false)}>
          <DialogTitle>Ajouter une nouvelle période</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Nouvelle période"
              fullWidth
              variant="standard"
              placeholder="Ex: 4mois, 5ans..."
              value={newPeriod}
              onChange={(e) => setNewPeriod(e.target.value)}
              disabled={disabled}

            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>Annuler</Button>
            <Button onClick={handleAddPeriod}>Ajouter</Button>
          </DialogActions>
        </Dialog>
      )}

    </div>
  );
};

export default PeriodSelector;
